import { render, staticRenderFns } from "./BitcoinList.vue?vue&type=template&id=3855c422&scoped=true"
import script from "./BitcoinList.vue?vue&type=script&lang=js"
export * from "./BitcoinList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855c422",
  null
  
)

export default component.exports